import { render, staticRenderFns } from "./aiComparisonHistory.vue?vue&type=template&id=16cefae1&scoped=true"
import script from "./aiComparisonHistory.vue?vue&type=script&lang=js"
export * from "./aiComparisonHistory.vue?vue&type=script&lang=js"
import style0 from "./aiComparisonHistory.vue?vue&type=style&index=0&id=16cefae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cefae1",
  null
  
)

export default component.exports